import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d85572e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/warningcenter.less?vue&type=style&index=0&id=6d85572e&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=6d85572e&scoped=true&lang=css&"
import style2 from "./index.vue?vue&type=style&index=2&lang=css&"
import style3 from "./index.vue?vue&type=style&index=3&id=6d85572e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d85572e",
  null
  
)

export default component.exports